import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";

import { handleGetItemsWithParam } from "../../shared/controllers/blogController";
import LoadingGrid from "../../utils/loadingGrid";
import PitchImagesCarousel from "../../utils/pitchImageCarousel";

import calendar from "./assets/calendar.svg";
import clock from "./assets/clock.svg";
import pin from "./assets/MapPin.svg";

interface Tournament {
    title: string;
    excerpt: string;
    location: string;
    date: string;
    time: string;
    media?: unknown;
}

const EventsLanding: React.FC = () => {
    const [tournaments, setTournaments] = useState<Tournament[]>([]);
    const [loading, setLoading] = useState(true);


    const normalizeTournaments = (response: unknown): Tournament[] => {
        const res = response as { data?: { data?: Tournament[] } | Tournament[] } | Tournament[];
        if (!res) return [];
        if (Array.isArray(res)) return res;
        if (Array.isArray((res as { data?: Tournament[] }).data)) return (res as { data?: Tournament[] }).data as Tournament[];
        if (Array.isArray((res as { data?: { data?: Tournament[] } }).data?.data)) return (res as { data?: { data?: Tournament[] } }).data?.data as Tournament[];
        return [];
    };

    const fetchTournaments = useCallback(async () => {
        const params = { type: "Tournaments" };
        try {
            const data = await handleGetItemsWithParam(params);
            setTournaments(normalizeTournaments(data));
        } catch (error) {
            console.error("Error fetching tournaments:", error);
            setTournaments([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTournaments();
    }, [fetchTournaments]);

    return (
        <>
            <section id="tournaments-section" className="w-full">
                <div
                    className="flex flex-col items-start justify-center py-12 md:py-16 w-full px-4 md:px-14"
                >
                    <h3>Our Tournaments</h3>
                    <h2 className="mt-3 font-Manrope">Discover Upcoming Tournaments</h2>

                    <div className=" mt-8 md:mt-8 w-full">
                        {loading ? (
                            <LoadingGrid count={3} />
                        ) : tournaments.length === 0 ? (
                            <div className=" flex w-full flex-row items-center justify-center mt-12">
                                <h3 className=" text-center font-Manrope text-lg text-black font-semibold">
                                    There are no tournaments available at this moment
                                </h3>
                            </div>
                        ) : (
                            <div className=" grid grid-cols-1 w-full gap-8">
                                {tournaments.map((item, index) => (
                                    <div
                                        key={index}
                                        className=" flex flex-col lg:flex-row justify-between w-full bg-[#F3F0E9] rounded-[20px]"
                                    >
                                        <div className=" w-full lg:w-[35%] min-h-[300px] rounded-[20px] overflow-hidden">
                                            <PitchImagesCarousel
                                                showIndicator={false}
                                                media={typeof item.media === 'string' ? JSON.parse(item.media) : item.media}
                                            />
                                        </div>
                                        <div className=" w-full lg:w-[65%] p-6 md:p-8">
                                            <p className=" font-Manrope font-bold text-xl md:text-2xl text-black">
                                                {item.title}
                                            </p>
                                            <p
                                                className=" mt-3 font-Manrope text-sm md:text-lg font-normal prose prose-sm"
                                                dangerouslySetInnerHTML={{ __html: item.excerpt }}
                                            ></p>

                                            <div className=" flex flex-wrap mt-3 md:mt-5  items-center gap-4">
                                                <div className=" flex items-center space-x-3">
                                                    <span className=" flex items-center space-x-2">
                                                        <img src={pin} alt="" />
                                                        <p className=" font-Manrope font-semibold text-sm md:text-base text-black">
                                                            Location:
                                                        </p>
                                                    </span>
                                                    <p className=" font-Manrope text-sm md:text-base font-normal text-black">
                                                        {item.location}
                                                    </p>
                                                </div>
                                                <div className=" flex items-center space-x-3">
                                                    <span className=" flex items-center space-x-2">
                                                        <img src={calendar} alt="" />
                                                        <p className=" font-Manrope font-semibold text-sm md:text-base text-black">
                                                            Date:
                                                        </p>
                                                    </span>
                                                    <p className=" font-Manrope text-sm md:text-base font-normal text-black">
                                                        {item.date}
                                                    </p>
                                                </div>
                                                <div className=" flex items-center space-x-3">
                                                    <span className=" flex items-center space-x-2">
                                                        <img src={clock} alt="" />
                                                        <p className=" font-Manrope font-semibold text-sm md:text-base text-black">
                                                            Time:
                                                        </p>
                                                    </span>
                                                    <p className=" font-Manrope text-sm md:text-base font-normal text-black">
                                                        {item.time}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {tournaments.length > 2 && (
                        <Link
                            to="/tournaments"
                            className="mt-8 md:mt-16 py-3 px-[18px] bg-[#317333] rounded-[6px] font-Manrope text-[#fff] font-semibold text-[15px] mx-auto"
                        >
                            View more
                        </Link>
                    )}
                </div>
            </section>
        </>
    );
};

export default EventsLanding;
